import Label from "common/components/ui/Label";
import RadioButton from "common/components/ui/RadioButton";
import { SUBSCRIPTION_STATUSES } from "common/constants";
import { typedObjectEntries } from "common/helpers/utils";
import useAppStore from "common/hooks/useAppStore";

export default function RentedSubscriptionStatus() {
  const subscriptionStatus = useAppStore(
    (state) => state.debugOptions.rentedSubscriptionStatus,
  );
  const isWithoutSubscription = useAppStore(
    (state) => state.debugOptions.isWithoutRentedSubscription,
  );

  const { in_trial: _in_trial, ...rentedSubscriptionStatuses } =
    SUBSCRIPTION_STATUSES;

  return (
    <>
      <span className="my-2 text-xs text-black-400">
        Rented Subscription Status
      </span>
      <div className="flex flex-wrap gap-2">
        <div className="flex gap-x-1">
          <RadioButton
            size="sm"
            id="defaultRentedSubscription"
            onChange={() =>
              useAppStore
                .getState()
                .setDebugOptions({ rentedSubscriptionStatus: null })
            }
            name="rentedSubscriptionStatus"
            checked={!subscriptionStatus}
          />
          <Label htmlFor="defaultRentedSubscription" size="sm">
            Default
          </Label>
        </div>
        {typedObjectEntries(rentedSubscriptionStatuses).map(([key, status]) => {
          const id = `rented-subscription-${key}`;

          return (
            <div className="flex gap-x-1" key={id}>
              <RadioButton
                size="sm"
                key={id}
                id={id}
                disabled={isWithoutSubscription}
                onChange={() =>
                  useAppStore
                    .getState()
                    .setDebugOptions({ rentedSubscriptionStatus: key })
                }
                name="rentedSubscriptionStatus"
                checked={subscriptionStatus === key}
              />
              <Label htmlFor={id} size="sm">
                {status}
              </Label>
            </div>
          );
        })}
      </div>
    </>
  );
}
